const TableFormRefInjectionKey = Symbol("tableFormRefInjectionKey");
const TableFormFieldRefInjectionKey = Symbol("tableFormFieldRefInjectionKey");
const TableFormRowInfoInjectionKey = Symbol("tableFormRowInfoInjectionKey");
const DatePickerValueIsArrayList = ["datetimerange", "daterange", "monthrange"];
const ValueIsNumberList = ["rate", "input-number", "slider"];
const ValueIsBooleanList = ["switch"];
const ValueIsArrayList = [
  "checkbox",
  "cascader",
  "plus-date-picker",
  "plus-input-tag",
  "transfer"
];

export { DatePickerValueIsArrayList, TableFormFieldRefInjectionKey, TableFormRefInjectionKey, TableFormRowInfoInjectionKey, ValueIsArrayList, ValueIsBooleanList, ValueIsNumberList };
